import React from 'react';
import { Check, X, MessageCircle } from 'lucide-react';
import { pricing, WHATSAPP } from '../mock';

const Pricing = () => {
  return (
    <section id="prezzi" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 scroll-mt-20">
      <div className="text-center max-w-3xl mx-auto mb-14 reveal">
        <span className="label-mono">// SCEGLI IL TUO PERCORSO</span>
        <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-5xl leading-tight">
          Tre livelli di formazione. <span className="gold-text">Un solo obiettivo.</span>
        </h2>
        <p className="mt-5 text-neutral-400">
          Scegli il pacchetto più adatto al tuo livello e ai tuoi obiettivi. Tutti includono accesso a vita e
          aggiornamenti futuri.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 items-start">
        {pricing.map((p, i) => (
          <div
            key={p.n}
            style={{ transitionDelay: `${i * 0.12}s` }}
            className={`relative rounded-2xl border p-8 flex flex-col ${
              p.featured
                ? 'border-[var(--uv-gold)] bg-[var(--uv-surface)] lg:-mt-4 lg:mb-4 shadow-[0_0_60px_-15px_rgba(227,178,60,0.35)]'
                : 'border-white/10 bg-[var(--uv-surface)]'
            } reveal-scale`}
          >
            {p.featured && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] text-xs font-bold tracking-wide">
                CONSIGLIATO
              </span>
            )}
            <div className="font-mono-uv text-[var(--uv-gold)] text-sm">{p.n}</div>
            <h3 className="mt-3 font-display font-bold text-white text-xl tracking-wide">{p.name}</h3>
            <p className="mt-3 text-sm text-neutral-400 leading-relaxed min-h-[3.5rem]">{p.desc}</p>
            <div className="mt-6 flex items-end gap-1">
              <span className="font-display font-bold text-white text-5xl">€ {p.price}</span>
            </div>

            <ul className="mt-7 space-y-3 flex-1">
              {p.features.map((f, i) => (
                <li key={i} className={`flex items-start gap-3 text-sm ${f.on ? 'text-neutral-200' : 'text-neutral-600 line-through'}`}>
                  {f.on ? (
                    <Check size={17} className="text-[var(--uv-gold)] mt-0.5 shrink-0" />
                  ) : (
                    <X size={17} className="text-neutral-600 mt-0.5 shrink-0" />
                  )}
                  {f.t}
                </li>
              ))}
            </ul>

            <a
              href={WHATSAPP}
              target="_blank"
              rel="noreferrer"
              className={`mt-8 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-semibold transition-colors ${
                p.featured
                  ? 'bg-[var(--uv-gold)] text-[#0c0c0e] hover:bg-[var(--uv-gold-soft)]'
                  : 'border border-white/25 text-white hover:border-[var(--uv-gold)] hover:text-[var(--uv-gold)]'
              }`}
            >
              {p.cta}
            </a>
          </div>
        ))}
      </div>

      {/* Bonus temporaneo */}
      <div className="mt-14 relative rounded-2xl overflow-hidden border border-[var(--uv-gold)]/40 bg-gradient-to-br from-[#1a160c] to-[#0c0c0e] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 reveal">
        <div className="max-w-2xl">
          <span className="label-mono">// BONUS TEMPORANEO</span>
          <h3 className="mt-3 font-display font-semibold text-white text-2xl md:text-3xl leading-snug">
            Scrivimi su WhatsApp. Per te fino a <span className="gold-text">80€ di sconto</span> immediato sul corso Advanced
          </h3>
          <p className="mt-3 text-neutral-400">
            Per un periodo limitato, se mi contatti personalmente, potrai accedere al corso Advanced con uno sconto di
            80€ immediati.
          </p>
        </div>
        <a
          href={WHATSAPP}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] font-semibold hover:bg-[var(--uv-gold-soft)] transition-colors shrink-0"
        >
          <MessageCircle size={18} /> Scrivimi su WhatsApp
        </a>
      </div>
    </section>
  );
};

export default Pricing;
